<template>
  <div class="container con-them">
    <div class="header">
      <div class="inner">
        <div class="logo">
          <router-link :to="'/'"><img :src="logoImage" :alt="logoTitle" /></router-link>
        </div>
        <div class="srch-account">
          <div class="m-account">
            <router-link :to="'/Login'" class="login-pg-btn"><i class="el-icon-user"></i>登录</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="inner">
      <div class="login-page">
        <div class="lg-form">
          <div class="lg-hd">
            <div class="item regis-ti">注册</div>
          </div>
          <div class="lg-bd">
            <div class="item regis-con">
              <el-form :model="ruleForm" :rules="rules" ref="submitForm" class="demo-ruleForm">
                <el-form-item prop="phone">
                  <el-input :placeholder="loginMode == 1 ? '请输入手机号' : '请输入账号'" v-model="ruleForm.phone"></el-input>
                </el-form-item>
                <el-form-item prop="code" v-if="loginMode == 1">
                  <el-input placeholder="请输入验证码" v-model="ruleForm.code">
                    <template slot="append">
                      <div v-if="isShow" @click="verification">获取验证码</div>
                      <div v-if="!isShow">重发<span>{{ count }}</span>s</div>
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item prop="pass">
                  <el-input type="password" placeholder="请输入密码" v-model="ruleForm.pass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="checkPass">
                  <el-input type="password" placeholder="再次确认密码" v-model="ruleForm.checkPass" autocomplete="off">
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitForm()">注册</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="lg-ft">您已有账号？请点击这里<router-link :to="'/Login'">立即登录</router-link></div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
    <select-school></select-school>
  </div>
</template>

<script>
import CommonFoot from "common/foot/Foot";
import SelectSchool from "./SelectSchool";
export default {
  name: "Register",
  components: {
    CommonFoot,
    SelectSchool
  },
  data: function () {
    var validPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.submitForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      // 登录方式 1：手机，2：账号
      loginMode: 1,
      isShow: true,
      count: 0,
      msg: "",
      ruleForm: { phone: "", pass: "", checkPass: "", code: "" },
      rules: {
        phone: [{ required: true, message: "请输入正确的手机号", pattern: /^1[3456789]\d{9}$/, trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        pass: [{ validator: validPass, trigger: 'blur' }],
        checkPass: [{ validator: validCheckPass, trigger: 'blur' }],
      },
      logoImage: require("@/assets/logo.png"),
      logoTitle: "BOOK KNOWLEDGE SEARCH (BKS)",
    }
  },
  async mounted() {
    await this.$onWait;
    if(this.http.GetOrgInfo().Cover) {
      this.logoImage = this.$bti.ServerUrl + this.http.GetOrgInfo().Cover;
    }
    this.loginMode = this.http.GetOrgInfo().LoginMode;
    this.logoTitle = this.http.GetOrgInfo().OrgName;
    document.title = this.logoTitle;
    if (this.loginMode == 2) {
      this.rules.phone = [{ required: true, message: "请输入正确的账号", pattern: /^\S{6,}$/, trigger: 'blur' }];
    }
  },
  methods: {
    submitForm: function () {
      this.$refs.submitForm.validate((valid) => {
        if (!valid) {
          this.$message.error('请检查输入！');
          return false;
        }
        let url = this.$bti.CheckSmsForRegister(null, true);
        var params = {
          phone: this.ruleForm.phone,
          pass: this.ruleForm.pass,
          code: this.ruleForm.code,
          schoolId: this.http.GetOrgInfo().Id,
          position: this.$route.query.position
        };
        this.http.postParam(url, params, "正在注册....").then((res) => {
          if (res.code != 1) {
            this.$message.error(res.data);
            return;
          }
          // this.$message({message: res.data, type: 'success'});
          // window.location.href = "/login";
          this.$bti.GetJwtoken({phone: this.ruleForm.phone, pass: this.ruleForm.pass}).then((res) => {
            if (res.code != 1) {
              this.$message({ type: "error", message: res.info, showClose: true });
              return;
            }
            this.$store.commit("saveToken", res.token);
            this.$notify({ type: "success", message: "欢迎你," + this.ruleForm.phone + "", duration: 3000 });
            this.$router.replace("/");
          });
        });
      });
    },
    verification() {
      if (this.ruleForm.phone == "") {
        this.$message.error("请输入手机号码");
        return;
      }
      let url = this.$bti.GetSmsForRegister(null, true);
      this.http.postParam(url, {"tel": this.ruleForm.phone}, "正在发送....").then((result) => {
        if (result.code != 1) {
          this.$message.error(result.info);
          return;
        }
        this.$message.success("短信发送成功");
        this.isShow = false;
        this.count = 60;
        var times = setInterval(() => {
          this.count--;
          if (this.count <= 0) {
            this.isShow = true;
            clearInterval(times);
          }
        }, 1000);
      });
    },
  },
}
</script>

<style lang="css" scoped>
.login-page .lg-bd .item {
  display: block;
}

.lg-form .lg-hd {
  margin-top: 0px;
  border-bottom: none;
}

.lg-form .lg-hd .item.regis-ti {
  width: 100%;
  text-align: center;
}

.lg-form .lg-bd {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/account/Register.vue